import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              
              <span className="logo-text gold-text">$GOLD</span>
            </div>
            <p className="footer-tagline">Gold is eating everything.</p>
            <p className="footer-description">
              The ultimate meme coin celebrating gold's historic bull run. 
              Not financial advice. DYOR.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Quick Links</h4>
              <a href="#about">About</a>
              <a href="#tokenomics">Tokenomics</a>
              <a href="#howtobuy">How to Buy</a>
              <a href="#roadmap">Roadmap</a>
            </div>

            <div className="footer-column">
              <h4>Resources</h4>
              <a href="https://app.uniswap.org" target="_blank" rel="noopener noreferrer">Uniswap</a>
              <a href="https://dextools.io" target="_blank" rel="noopener noreferrer">DexTools</a>
              <a href="https://etherscan.io" target="_blank" rel="noopener noreferrer">Etherscan</a>
              <a href="https://coingecko.com" target="_blank" rel="noopener noreferrer">CoinGecko</a>
            </div>

            <div className="footer-column">
              <h4>Community</h4>
              <a href="https://x.com/goldonerc" target="_blank" rel="noopener noreferrer">Twitter / X</a>
              <a href="https://t.me/goldonerc" target="_blank" rel="noopener noreferrer">Telegram</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-disclaimer">
            <p>⚠️ Disclaimer: $GOLD is a meme coin with no intrinsic value. Cryptocurrency investments are highly risky. 
            Never invest more than you can afford to lose. This is not financial advice.</p>
          </div>
          <div className="footer-copyright">
            <p>© 2026 $GOLD. All rights reserved. Made with 💛 by the community.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
